export default "__VITE_ASSET__DE5sEMZL__"